import { Component, OnInit } from '@angular/core';
import {
  ConsignacoesService,
  ConsignacaoResumo,
  ConsignacaoDetalhe,
} from './relatorio-consignacoes.service';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Router } from '@angular/router';

declare const $: any;

@Component({
  selector: 'app-relatorio-consignacoes',
  templateUrl: './relatorio-consignacoes.component.html',
  styleUrls: ['./relatorio-consignacoes.component.css'],
})
export class RelatorioConsignacoesComponent implements OnInit {
  competencias: any[] = [];
  selectedCompetencia = '';
  sigla = '';
  empfil = '';
  Math = Math;

  resumo: ConsignacaoResumo[] = [];
  proventos: ConsignacaoResumo[] = [];
  descontos: ConsignacaoResumo[] = [];

  detalheRubrica = '';
  detalheTitulo = '';
  detalhes: ConsignacaoDetalhe[] = [];

  loadingList = false;
  loadingDetalhe = false;
  errorMessage = '';

  localStorage: LocalStorage;

  detalheTipo: 'PROVENTOS' | 'DESCONTOS' | '' = '';
  totalRegistros: number = 0;
  valorTotal: number = 0;

  constructor(private consignacoesService: ConsignacoesService, private router: Router) {
    this.localStorage = this.decryptLocalStorage();
    this.verificarAutenticacao();
    this.carregarDadosLocalStorage();
  }

  ngOnInit(): void {
    this.carregarCompetencias();
  }

  private obterCredencialBase64(): string {
    try {
      const utilCriptografado = localStorage.getItem('util');
      if (!utilCriptografado) return '';
      const utilDecriptado = new Crypto().decryptUsingAES256(utilCriptografado);
      const localStorageObj = JSON.parse(utilDecriptado);
      return localStorageObj?.CredencialBase64 ?? '';
    } catch {
      return '';
    }
  }

  private verificarAutenticacao(): void {
    const credencialBase64 = this.obterCredencialBase64();
    if (!credencialBase64) {
      this.router.navigate(['/login']);
      return;
    }
  }

  private carregarDadosLocalStorage(): void {
    this.sigla = this.localStorage?.Sigla ?? '';
    this.empfil = String(this.localStorage?.FilialAtual ?? '');
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
    return null;
  }

  carregarCompetencias(): void {
    this.consignacoesService.listarCompetencias(this.sigla, this.empfil).subscribe({
      next: (data: any) => {
        this.competencias = Array.isArray(data?.result) ? data.result : [];
      },
      error: (err) => {
        console.error(err);
        this.errorMessage = 'Erro ao carregar competências.';
      },
    });
  }

  listar() {
    if (!this.selectedCompetencia) {
      this.errorMessage = 'Selecione uma competência.';
      return;
    }

    if (!this.sigla || !this.empfil) {
      this.errorMessage = 'Sigla ou filial não encontradas. Faça login novamente.';
      return;
    }

    this.errorMessage = '';
    this.loadingList = true;

    this.consignacoesService
      .listarResumo(this.sigla, this.selectedCompetencia, this.empfil)
      .subscribe({
        next: (res) => {
          const proventosProcessados = this.processarRubricas(res.result?.proventos || [], false);
          const descontosProcessados = this.processarRubricas(res.result?.descontos || [], true);

          this.resumo = [...proventosProcessados, ...descontosProcessados];
          this.proventos = proventosProcessados;
          this.descontos = descontosProcessados;

          this.loadingList = false;
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = 'Erro ao listar consignações.';
          this.loadingList = false;
        },
      });
  }

  /** Converte valores no formato BR para número real */
  private toNumber(valor: any): number {
    if (typeof valor === 'number') return valor;
    if (!valor) return 0;

    return parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));
  }

  /** Soma valores agrupando por tipo folha + rubrica */
  private processarRubricas(dados: any[], isDesconto: boolean): ConsignacaoResumo[] {
    const rubricasAgrupadas: { [key: string]: ConsignacaoResumo } = {};

    dados.forEach((item) => {
      const chave = `${item.folha}_${item.verba.codigo}`;

      if (!rubricasAgrupadas[chave]) {
        rubricasAgrupadas[chave] = {
          tipoFolha: item.folha.trim(),
          rubricaCodigo: item.verba.codigo,
          rubricaDescricao: item.verba.nome,
          valor: 0,
          isDesconto: isDesconto,
        };
      }

      const valorNumerico = this.toNumber(item.valor);
      rubricasAgrupadas[chave].valor += valorNumerico;
    });

    return Object.values(rubricasAgrupadas);
  }

  baixarCSV() {
    if (!this.detalhes || this.detalhes.length === 0) return;
  
    const headers = [
      'Matrícula',
      'Nome',
      'Situação',
      'Lotação',
      'Vínculo',
      'Admissão',
      'Cargo',
      'Pag',
      'Oco',
      'Valor'
    ];

    const q = (v: any) => {
      const s = v == null ? '' : String(v);
      const escaped = s.replace(/"/g, '""');
      return `"${escaped}"`;
    };
  
    const linhas = this.detalhes.map((d) => [
      q(d.matricula),
      q(d.nome),
      q(d.situacao?.nome ?? ''),
      q(d.lotacao),
      q(d.vinculo),
      q(this.formatarDataAdmissao(d.admissao)), 
      q(d.cargo_funcao),
      q(d.pag),
      q(d.oco),
      q(this.formatarValor(d.valor))
    ]);

    let csv = '\uFEFF' + headers.map(h => `"${h.replace(/"/g, '""')}"`).join(';') + '\r\n'; 
    linhas.forEach((l) => {
      csv += l.join(';') + '\r\n';
    });
  
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
  
    a.href = url;
    a.download = this.gerarNomeArquivo();

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  
    URL.revokeObjectURL(url);
  }
  
  private formatarDataAdmissao(data: any): string {
    if (!data) return '';

    if (typeof data === 'string') {

      if (data.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
        const partes = data.split('/');
        if (partes.length === 3) {
          const dd = partes[0].padStart(2, '0');
          const mm = partes[1].padStart(2, '0');
          const yyyy = partes[2];
          return `${dd}/${mm}/${yyyy}`;
        }
      }
    }

    try {
      const dataObj = new Date(data);
      if (!isNaN(dataObj.getTime())) {
        const dd = String(dataObj.getDate()).padStart(2, '0');
        const mm = String(dataObj.getMonth() + 1).padStart(2, '0');
        const yyyy = dataObj.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
      }
    } catch (e) {
      console.warn('Erro ao formatar data:', e);
    }
    
    return String(data || '');
  }
  
  private formatarValor(valor: any): string {
    if (valor === null || valor === undefined) return '0,00';

    let num: number;
    if (typeof valor === 'string') {
      num = parseFloat(valor.replace(/\./g, '').replace(',', '.'));
    } else {
      num = Number(valor);
    }
    
    if (isNaN(num)) return '0,00';

    return num.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  
  private gerarNomeArquivo(): string {
    const competencia = this.selectedCompetencia || '000000';
  
    let rubricaCodigo = '000';
    if (this.detalheRubrica) {
      rubricaCodigo = this.detalheRubrica;
    } else if (this.detalheTitulo) {
      const match = this.detalheTitulo.match(/(\d+)/);
      if (match) {
        rubricaCodigo = match[1];
      }
    }
  
    let rubricaSigla = 'RUB';
    if (this.detalheTitulo) {
      const partes = this.detalheTitulo.split('-');
      if (partes.length > 1) {
        const descricao = partes[1].trim();
        rubricaSigla = descricao.substring(0, 40).toUpperCase();
      }
    }
  
    const nomeLimpo = `rel-consig-${competencia}-${rubricaCodigo}-${rubricaSigla}.CSV`
      .replace(/[^a-zA-Z0-9-_.]/g, '');
  
    return nomeLimpo;
  }

  abrirDetalhe(r: ConsignacaoResumo) {
    const rubricaParam = r.rubricaCodigo.includes('.')
      ? r.rubricaCodigo.split('.')[0]
      : r.rubricaCodigo;
  
    this.detalheRubrica = rubricaParam;
    this.detalheTitulo = `${r.tipoFolha} ${r.rubricaCodigo} - ${r.rubricaDescricao}`;
    this.detalheTipo = r.isDesconto ? 'DESCONTOS' : 'PROVENTOS';
    this.loadingDetalhe = true;
    this.detalhes = [];
    this.totalRegistros = 0;
    this.valorTotal = 0;
  
    try {
      $('#exampleModal').modal('show');
    } catch (e) {
      console.error('Erro ao abrir modal:', e);
    }
  
    this.consignacoesService
      .listarDetalhes(this.sigla, this.selectedCompetencia, this.empfil, rubricaParam)
      .subscribe({
        next: (res: any) => {
          const lista = r.isDesconto ? res?.result?.descontos : res?.result?.proventos;
  
          if (lista) {
            this.detalhes = lista.map((item: any) => ({
              transacao: item.transacao,
              valor: this.toNumber(item.valor), 
              competencia: item.competencia,
              folha: item.folha,
              filial: item.filial,
              matricula: item.matricula,
              nome: item.nome,
              lotacao: item.lotacao,
              vinculo: item.vinculo,
              admissao: item.admissao,
              cargo_funcao: item.cargo_funcao,
              oco: item.oco,
              pag: item.pag,
              situacao: item.situacao,
              verba: item.verba,
            }));

            this.totalRegistros = this.detalhes.length;
            this.valorTotal = this.detalhes.reduce((total: number, item: ConsignacaoDetalhe) => {
              const valor = Number(item.valor) || 0; 
              return total + valor;
            }, 0);
          }
  
          this.loadingDetalhe = false;
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = 'Erro ao carregar detalhes.';
          this.loadingDetalhe = false;
        },
      });
  }
}
